import { motion } from "framer-motion";
import { MaskLines, Overline, Reveal, EASE } from "./Motion";
import { AMENITIES, IMG } from "../../lib/site";

export const Amenities = () => (
  <section id="amenities" data-testid="amenities-section" className="relative bg-[#0E131D] py-24 lg:py-36">
    <div className="mx-auto grid max-w-7xl gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Overline>Amenities & Facilities</Overline>
          <MaskLines className="font-display mt-6 text-4xl sm:text-5xl font-semibold tracking-[-0.03em] leading-[1.04] text-white"
            lines={["Everything handled.", <span className="text-gold">Just bring your laptop.</span>]} />
          <Reveal delay={0.1} className="mt-10 overflow-hidden rounded-[24px] border border-white/10">
            <img src={IMG.meetingA} alt="Meeting room facility" loading="lazy" className="aspect-[16/11] w-full object-cover" />
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 overflow-hidden rounded-[24px] border border-white/10 bg-white/10 gap-px self-start">
        {AMENITIES.map((a, i) => {
          const Icon = a.icon;
          return (
            <motion.div key={a.name} data-testid="amenities-grid-item"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.05 }}
              className="group relative flex min-h-[170px] sm:min-h-[200px] flex-col justify-between bg-[#131924] p-5 sm:p-7 transition-colors duration-500 hover:bg-[#1A2332]">
              <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-[#D4AF37] transition-transform duration-500 group-hover:scale-x-100" />
              <Icon className="h-7 w-7 text-[#D4AF37] transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.5} />
              <div>
                <span className="font-mono-k text-[11px] text-slate-400">{String(i + 1).padStart(2, "0")}</span>
                <p className="font-display mt-1 text-base sm:text-lg leading-snug text-white">{a.name}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
